import styled from "styled-components";
import { Checkbox, Card, Button } from "antd";

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 16px;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const Question = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`;

export const UpperCaseHeading = styled.h1`
  text-transform: uppercase;
  color: #fdd440 !important;
  font-weight: bold;
  font-size: 30px;
  @media (min-width: 768px) {
    font-size: 40px;
  }
`;

export const AnswersCard = styled(Card)`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 15px;
  overflow: hidden;
  margin: 0 auto;

  @media (min-width: 768px) {
    max-width: 80%;
  }
`;

export const CardContent = styled.div<{ isSelected: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 16px;
  border: 2px solid #ccc;
  padding-left: 30px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #e6f7ff;
    border-color: #1890ff;
  }

  ${(props) =>
    props.isSelected &&
    `
    color: #1890ff;
    background-color: #e6f7ff;
    border-color: #1890ff;
  `}
  .icon-text-group {
    display: flex;
    align-items: center;
  }
`;

export const IconContainer = styled.span`
  display: flex;
  align-items: center;
  margin-right: 15px;

  .icon {
    font-size: 24px; /* Adjust size as needed */
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  display: block;
  margin: 8px;

  .ant-checkbox-inner {
    width: 30px;
    height: 30px;
  }
  .ant-checkbox-inner::after {
    width: 12px;
    height: 17px;
  }
`;

export const ContinueButton = styled(Button)`
  width: 100%;
  font-size: 30px;
  height: 60px;
  color: #1070b6;
  background: #fdd440 !important;
  font-weight: bold;
  margin-top: auto;
  align-self: flex-end;
`;

export const ResponsiveGrid = styled(Card.Grid)`
  width: 100%;
  padding: 24px;

  @media (max-height: 900px) {
    padding: 14px;
  }
  @media (max-height: 600px) {
    padding: 10px;
  }
`;
